import { useState } from "react";

export default function BinarySelectV2025({
  valueLeft = "LEFT",
  valueRight = "RIGHT",
  onChange = null,
  errorMsg = "",
  valuePicked = "",
}) {
  const [valuePickedState, setValuePickedState] = useState(valuePicked || valueRight);

  return (
    <div className="bg-[#F0F1F4] flex h-[60px] items-center p-[4px] rounded-[16px] w-full">
      <div
        onClick={() => {
          setValuePickedState(valueLeft);
          onChange(valueLeft);
        }}
        className={`flex flex-1 h-[52px] items-center justify-center py-[17px] relative rounded-[12px] cursor-pointer transition-all duration-200 ${
          valuePickedState === valueLeft
            ? "linear-background-color-primary"
            : "bg-transparent"
        }`}
        tabIndex={0}
      >
        <p
          className={`font-poppins text-[16px] text-center leading-[21px] tracking-[0px] ${
            valuePickedState === valueLeft
              ? "font-medium text-white"
              : "font-normal text-[#99A3B2]"
          }`}
        >
          {valueLeft}
        </p>
      </div>

      <div
        onClick={() => {
          setValuePickedState(valueRight);
          onChange(valueRight);
        }}
        className={`flex flex-1 h-[52px] items-center justify-center py-[17px] relative rounded-[12px] cursor-pointer transition-all duration-200 ${
          valuePickedState === valueRight
            ? "linear-background-color-primary"
            : "bg-transparent"
        }`}
        tabIndex={0}
      >
        <p
          className={`font-poppins text-[16px] text-center leading-[21px] tracking-[0px] ${
            valuePickedState === valueRight
              ? "font-medium text-white"
              : "font-normal text-[#99A3B2]"
          }`}
        >
          {valueRight}
        </p>
      </div>
    </div>
  );
}
